import type { SiteConfigFn } from '@wix/thunderbolt-vsm-api-types'

const storesSiteConfig: SiteConfigFn<Record<string, never>> = () => {
	return {
		shouldLoadSiteFeature: true,
		shouldLoadSiteConfig: false,
		siteConfig: null,
	}
}

const name = 'stores'

export const config = {
	site: storesSiteConfig,
	reactRendererSite: storesSiteConfig,
	reactNativeSite: storesSiteConfig,
	name,
}
